import axios from "@/plugins/axios";

export const login = (data) => {
  return axios.post("/v1/login", data).then((res) => res.data);
};
